module.exports = __webpack_public_path__ + "img/cover-mobile.d8d202be.jpg";